var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.347.793H12.653A2.656 2.656 0 0010 3.446v9.347H2.653A2.656 2.656 0 000 15.446v43.761l9.414-9.414h34.933A2.656 2.656 0 0047 47.14v-6.347h3.586L60 50.207V3.446A2.656 2.656 0 0057.347.793zM45 47.14c0 .36-.293.653-.653.653H8.586L2 54.379V15.446c0-.36.293-.653.653-.653h41.694c.36 0 .653.293.653.653V47.14zm13-1.761l-6.586-6.586H47V15.446a2.656 2.656 0 00-2.653-2.653H12V3.446c0-.36.293-.653.653-.653h44.694c.36 0 .653.293.653.653v41.933z"
  })));
}
export default SvgIconChat;